import { render, staticRenderFns } from "./ListUserEvaluations.vue?vue&type=template&id=5b979009&"
import script from "./ListUserEvaluations.vue?vue&type=script&lang=js&"
export * from "./ListUserEvaluations.vue?vue&type=script&lang=js&"
import style0 from "./ListUserEvaluations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports